<template>
    <div>
        <center>
        <div v-if="!isPost" class="no-post">Без обработки</div>
        <div v-if="isPost">
            <div class="detail-container">
                  <table width="90%" border=0 class="post_table" key="dtable">
                    <tr>
                        <td width=50px align=left></td>
                        <td align=center height="10px">        
                            <div class="no-wrap">
                                <div v-for="item in postList" :key=item.id class="horizontal post-name">
                                   <span v-if="isSet('top', item)">
                                       <q-icon name="done"/>
                                            {{item.shortName}} 
                                                <q-tooltip :delay="1000">
                                                    {{item.name}}
                                                </q-tooltip>
                                    </span>
                                </div>
                            </div>
                        </td>   
                        <td></td>
                    </tr>
                    <tr>
                        <td width=50px align=left>
                                <div v-for="item in postList" :key=item.id class="post-name vertical">
                                    <span v-if="isSet('left', item)"><q-icon name="done"/> {{item.shortName}} 
                                                <q-tooltip :delay="1000">
                                                    {{item.name}}
                                                </q-tooltip>
                                    </span>
                                </div>
                        </td>

                        <td style="border:2px solid gray;" align=left valign=middle height='50px'>
                            <div v-for="item in centerInfo" :key=item.id>
                                <div class="icon-container"><img :src="'/static/'+item.icon" class="post-icon"></div>
                                <div class='post-name-container'>{{item.name}}</div>
                                <div style="clear:both"></div>
                            </div>

                        </td>

                        <td  width=50px align=left valign=center>
                                <div v-for="item in postList" :key=item.id class="post-name vertical">
                                    <span v-if="isSet('right', item)"><q-icon name="done"/> {{item.shortName}}
                                            <q-tooltip :delay="1000">
                                                {{item.name}}
                                            </q-tooltip>
                                    </span>
                                </div>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td align=center>       
                            <div class=" no-wrap">
                                <div v-for="item in postList" :key=item.id class="post-name horizontal">
                                   <span v-if="isSet('bottom', item)"> <q-icon name="done"/> {{item.shortName}} 
                                        <q-tooltip :delay="1000">
                                                    {{item.name}}
                                        </q-tooltip>
                                   </span>
                                </div>
                            </div>
                        </td>   
                        <td></td>
                    </tr>
                </table>
            </div>
       </div>
       </center>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name : 'printTerminalShowPost',
    props : {
        order : {
            type: Object,
            requered: true,
        },
    },
    data () {
            return {
                options : null,
                postOptions : [] // содержит массив постобработки
            }
    },

    created(){
        var q = JSON.parse(this.order.options);
        this.postOptions = (q.post) ? q.post : [];
        // if (q != null) this.postOptions = q[1];
        
    },

    computed : {

        postList() {
            return this.$store.getters.getPerimeterPostTypes;
        },

        centerInfo() {
            var result = [];
            var p = this.postOptions['space'];
            if (p.length>0) { // якобы тут есть постобработка по площади (например ламинация или перфорация)
                for (let i = 0; i < p.length; i++) {
                    let item = this.$store.getters.getPostTypeById(p[i]);
                    if (item != null) {
                        result.push(item);
                    } 
                }
            } 
            return result;
        },

        isPost() {
            var result = false;
            if (this.postOptions == undefined) return result;
            for (let key in this.postOptions) {
                 if ((this.postOptions[key]!= undefined) && (this.postOptions[key].length > 0)) result = true;
            }
            return result;
        },

        isCenterPost() {

        }

    },

    methods : {
        isSet(side, postId) {
           if (this.postOptions[side].indexOf(postId.id)>-1) return true;
           return false;
        }
    }

}
</script>

<style lang="scss" scoped>
    .horizontal {
        display: inline;
        margin-left: 10px;
        margin-right: 10px;

    }
    .post-name {
        font-family: Arial, Helvetica, sans-serif;
        font-size : 15px;
        font-weight: bold;
        color : red
    }
    .vertical {
        margin-top:5px;
        margin-bottom:5px;
    }
    .no-post {
        font-family: Arial, Helvetica, sans-serif;
        font-size : 20px;
        font-weight: bold;
        color : red;
        margin-top:20px;
    }
    .post-icon {
        height:40px;
        margin-right:10px;
    }
    .icon-container {
        margin-left:10%;
        height : 40px;
        float: left;
    }
    .post-name-container {
        height: 40px;
        padding :15px;
        font-family: Arial, Helvetica, sans-serif;
        font-size : 14px;
        cursor: default;
        &:hover {
            background: rgb(209, 250, 209)
        }
    }
</style>
